<template>
    <div>
        <vue-echarts :option="option" style="height: 500px; min-width: 1200px;" ref="chart" autoResize />
    </div>
</template>

<script>
import { VueEcharts } from "vue3-echarts";

import { useStore } from "@/store";
const store = useStore();

export default {
    name: 'stackProvinceHor',
    data() {
        return {
            fragileStackBarChartProvinceNameArray: [],
            fragileStackBarChartProvinceData1Array: [],
            fragileStackBarChartProvinceData2Array: [],
            fragileStackBarChartProvinceData3Array: [],
            fragileStackBarChartProvinceData4Array: []
        }
    },
    props: {
        fragileStackBarChartProvince: Array
    },
    methods: {
        barCount() {
            return Array.isArray(this.fragileStackBarChartProvince)
                ? this.fragileStackBarChartProvince.length
                : 0;
        },
        calcXAxisFontSize() {
            const n = this.barCount();
            if (n <= 5) return 16;
            if (n <= 10) return 14;
            if (n <= 20) return 12;
            if (n <= 35) return 11;
            return 10;
        },
        calcXAxisRotate() {
            const n = this.barCount();
            if (n <= 12) return 0;
            if (n <= 25) return 30;
            return 45;
        },
        calcXAxisLabelWidth() {
            const n = this.barCount();
            if (n <= 12) return 160;
            if (n <= 25) return 110;
            return 80;
        },
        fragileStackBarChartProvinceName() {
            this.fragileStackBarChartProvinceNameArray = [];
            this.fragileStackBarChartProvince.forEach(element => {
                if ((store.state.mainFilterSearch.provID == 0 && store.state.mainFilterSearch.ampID == 0 && store.state.mainFilterSearch.tambolID == 0)) {
                    this.fragileStackBarChartProvinceNameArray.push(element.province_name);
                } else if ((store.state.mainFilterSearch.provID != 0 && store.state.mainFilterSearch.ampID == 0 && store.state.mainFilterSearch.tambolID == 0)) {
                    this.fragileStackBarChartProvinceNameArray.push(element.amphur_name);
                } else if (store.state.mainFilterSearch.provID != 0 && store.state.mainFilterSearch.ampID != 0 && store.state.mainFilterSearch.tambolID == 0) {
                    this.fragileStackBarChartProvinceNameArray.push(element.tumbol_name);
                } else if ((store.state.mainFilterSearch.provID != 0 && store.state.mainFilterSearch.ampID != 0 && store.state.mainFilterSearch.tambolID != 0)) {
                    this.fragileStackBarChartProvinceNameArray.push(element.village_name);
                }
            });
            return this.fragileStackBarChartProvinceNameArray;
        },
        fragileStackBarChartProvinceData1() {
            this.fragileStackBarChartProvinceData1Array = [];
            this.fragileStackBarChartProvince.forEach(element => {
                this.fragileStackBarChartProvinceData1Array.push(element.fg0);
            });
            return this.fragileStackBarChartProvinceData1Array;
        },
        fragileStackBarChartProvinceData2() {
            this.fragileStackBarChartProvinceData2Array = [];
            this.fragileStackBarChartProvince.forEach(element => {
                this.fragileStackBarChartProvinceData2Array.push(element.fg1);
            });
            return this.fragileStackBarChartProvinceData2Array;
        },
        fragileStackBarChartProvinceData3() {
            this.fragileStackBarChartProvinceData3Array = [];
            this.fragileStackBarChartProvince.forEach(element => {
                this.fragileStackBarChartProvinceData3Array.push(element.fg2);
            });
            return this.fragileStackBarChartProvinceData3Array;
        },
        fragileStackBarChartProvinceData4() {
            this.fragileStackBarChartProvinceData4Array = [];
            this.fragileStackBarChartProvince.forEach(element => {
                this.fragileStackBarChartProvinceData4Array.push(element.fg3);
            });
            return this.fragileStackBarChartProvinceData4Array;
        },
    },
    components: {
        VueEcharts,
    },
    mounted() {
        setTimeout(function () {
            this.$nextTick(() => {
                this.$refs.chart.setOption(this.option);
            })
        }.bind(this), 300)
    },
    computed: {
        option() {
            return {
                tooltip: {
                    trigger: 'axis',
                    confine: 'true',
                    axisPointer: {
                        type: 'shadow'
                    },
                    textStyle: {
                        fontFamily: 'kanit',
                        fontSize: 12,
                        fontWeight: '400',
                        color: '#728196'
                    },
                    backgroundColor: '#f3f6f9',
                    borderColor: 'none',
                    // extraCssText: 'max-width: 270px',
                    extraCssText: 'max-width: 260px; min-width: 255px',
                    formatter: function (params) {
                        var colorSpan = color => '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + color + '"></span>';
                        var formatFixed = value => new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 0,
                        }).format(value.toFixed(0));
                        return "<b style='color: #1d4481; font-size: 1.2em'> " + ` ${params[0].name} </b><br/>
                        <table style="max-width: 150px">
                            <th>
                                <tr>
                                    <td style="width: 100%;"></td>
                                    <td style="width: auto;"></td>
                                    <td style="width: 10%;min-width: 25px; float: right;"></td>
                                </tr>
                            </th>
                            <tbody>
                                <tr>
                                    <td>ครัวเรือนเปราะบางทั้งหมด</td>
                                    <td class="text-right">${formatFixed(params[0].value + params[1].value + params[2].value + params[3].value)}</td>
                                    <td class="text-right">ครัวเรือน</td>
                                </tr>
                                <tr>
                                    <td>${colorSpan(params[0].color)} ${params[0].seriesName}</td>
                                    <td class="text-right">${formatFixed(params[0].value)}</td>
                                    <td class="text-right">ครัวเรือน</td>
                                </tr>
                                <tr>
                                    <td>${colorSpan(params[1].color)} ${params[1].seriesName}</td>
                                    <td class="text-right">${formatFixed(params[1].value)}</td>
                                    <td class="text-right">ครัวเรือน</td>
                                </tr>
                                <tr>
                                    <td>${colorSpan(params[2].color)} ${params[2].seriesName}</td>
                                    <td class="text-right">${formatFixed(params[2].value)}</td>
                                    <td class="text-right">ครัวเรือน</td>
                                </tr>
                                <tr>
                                    <td>${colorSpan(params[3].color)} ${params[3].seriesName}</td>
                                    <td class="text-right">${formatFixed(params[3].value)}</td>
                                    <td class="text-right">ครัวเรือน</td>
                                </tr>
                            </tbody>
                        </table>`;
                    },
                },
                textStyle: {
                    fontFamily: 'kanit',
                    fontWeight: 'normal'
                },
                legend: {
                    show: false,
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '0px',
                    containLabel: true
                },
                radarAxis: {
                    axisTick: {
                        show: false
                    },
                },
                color: ['#7bbae0', '#e1dfa6', '#dd9090', '#925050'],
                xAxis: {
                    type: 'category',
                    data: this.fragileStackBarChartProvinceName(),
                    axisLabel: {
                        interval: 0,
                        rotate: this.calcXAxisRotate(),
                        fontSize: this.calcXAxisFontSize(),
                        width: this.calcXAxisLabelWidth(),
                        overflow: "truncate",
                        ellipsis: "...",
                        hideOverlap: true
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: false
                    }
                },
                series: [
                    {
                        name: 'เปราะบางระดับ 0',
                        type: 'bar',
                        stack: 'Ad',
                        emphasis: {
                            focus: 'series'
                        },
                        silent: true,
                        data: this.fragileStackBarChartProvinceData1()
                    },
                    {
                        name: 'เปราะบางระดับ 1',
                        type: 'bar',
                        stack: 'Ad',
                        emphasis: {
                            focus: 'series'
                        },
                        silent: true,
                        data: this.fragileStackBarChartProvinceData2()
                    },
                    {
                        name: 'เปราะบางระดับ 2',
                        type: 'bar',
                        stack: 'Ad',
                        emphasis: {
                            focus: 'series'
                        },
                        silent: true,
                        data: this.fragileStackBarChartProvinceData3()
                    },
                    {
                        name: 'เปราะบางระดับ 3',
                        type: 'bar',
                        stack: 'Ad',
                        emphasis: {
                            focus: 'series'
                        },
                        silent: true,
                        data: this.fragileStackBarChartProvinceData4()
                    }
                ],
                animation: true
            }
        },
    },
};
</script>

<style scoped>
.chart {
    height: 100vh;
}
</style>